<template>
  <div class="marketInspetionModify-box">
    <van-nav-bar
      :title="pageTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="box-content">
      <div class="content-item item-title">
        <van-field
          v-model="form.title"
          label-width="1rem"
          name="标题"
          required
          :disabled="dis"
          label="标题"
          placeholder="请填写标题"
          maxlength="20"
          show-word-limit
          @focus="() => (form.isFocus = true)"
          @blur="() => (form.isFocus = false)"
          :rules="[{ required: true }]"
        >
          <template #extra>
            <p class="fieId-title-p" @click="onTitleClear">
              <van-icon
                :class="[
                  'fieId-title-extra',
                  { 'fieId-title-extra-show': form.isFocus },
                ]"
                name="clear"
              />
            </p>
          </template>
        </van-field>
      </div>
      <div class="content-item">
        <van-field
          clearable
          required
          :disabled="dis"
          v-model="form.remark"
          label-width="1rem"
          name="描述"
          label="描述"
          :rows="5"
          maxlength="500"
          show-word-limit
          autosize
          type="textarea"
          placeholder="请填写描述"
        />
      </div>
      <div class="content-item">
        <van-field
          clearable
          required
          :disabled="dis"
          v-model="form.address"
          label-width="1rem"
          name="地点"
          :rows="3"
          label="地点"
          maxlength="50"
          show-word-limit
          :right-icon="dis?'':'location-o'"
          @click-right-icon="onClickRightIcon"
          type="textarea"
          placeholder="请定位地点"
          :rules="[{ required: true }]"
        />
      </div>
      <div class="content-item">
        <table>
          上传图片
        </table>
        <div class="item-upload">
          <van-uploader 
            required
            :show-upload="!dis"
            :deletable="!dis"
            :before-delete="deleteImg"
            :before-read="beforeRead"
            :after-read="afterRead"
            v-model="fileList"
            :preview-options="{closeable: true}"
            multiple
          />
        </div>
        <!-- <van-field
          colon
          clearable
          v-model="form.location"
          label-width="1rem"
          name="地点"
          label="地点"
          rows="2"
          autosize
          right-icon="location-o"
          @click-right-icon="onClickRightIcon"
          type="textarea"
          placeholder="请定位地点"
          :rules="[{ required: true }]"
        /> -->
      </div>
    </div>
    <div class="bottom">
      <van-row type="flex" justify="center" align="center">
        <van-col span="5" offset="1">
          <v-button class="btn" @click="zcOrSb(1)" v-if="!dis">暂存</v-button>
        </van-col>
        <van-col span="5" offset="1">
          <v-button class="btn" @click="zcOrSb(0)" v-if="!dis">上报</v-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import axios from 'axios'
import config from "@/config/index"; // 路径配置
import { loading } from '@/common/loading';
import {getFileDescList,deleteFileAjax,saveOrUpdateWarnInspection} from '@/api/baseMsg';
export default {
  name: "marketInspetionModify",
  components: {},
  computed: {},
  data() {
    return {
      pageTitle: "添加",
      dis: false,
      form: {
        id:'',
        title: "",
        remark: "",
        address: "",
        isFocus: false,
      },
      fileList: [],
      idArray:[],
      map: {
        point: null,
        address: "",
      },
      fleLength: 0,
      reLength: 0
    };
  },
  created() {
    if (Object.keys(this.$route.query).length > 0) {
      loading(true)
      this.pageTitle = "修改";
      this.form.id = this.$route.query.Id
      this.getFileDescList()
      this.form.title = this.$route.query.title
      this.form.remark = this.$route.query.remark
      this.form.address = this.$route.query.address
      this.map.point = {
        lat:'',
        lng:''
      }
      this.map.point.lat = this.$route.query.Latitude
      this.map.point.lng = this.$route.query.Longitude
      if(this.$route.query.state == 0 || this.$route.query.state == 2 ) {
        this.pageTitle = "查看";
        this.dis = true
      }
    } else {
      this.pageTitle = "添加";
    }
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.push({
          path: '/marketInspection/marketInspection',
      });
    },
    getFileDescList() {
      const params = {
        fid: this.form.id
      }
      getFileDescList(params).then(res=> {
        if(res.code == 200) {
          this.idArray = []
          res.data.forEach(i=> {
            this.idArray.push(i.fileId)
            i.url = i.absolutePath
          })
          this.fileList = res.data
        }
        setTimeout(() => {
          loading(false)
        }, 1500);
      })
    },
    // 标题清除
    onTitleClear() {
      this.form.title = "";
    },
    // 暂存1或上报0
    zcOrSb(val) {
      if(val == 0) {
        if(this.form.address == '' || this.form.remark == '' || this.form.title == '') {
          return Toast.fail('请完成必填项再上报！')
        }
        if(this.idArray.length == 0) {
          return Toast.fail('请至少上传一张图片！')
        }
      }
      loading(true)
      const params = {
        ID: this.form.id,
        address: this.form.address,
        flag: val,
        latitude: this.map.point?this.map.point.lat:'39.5420',
        longitude: this.map.point?this.map.point.lng:'116.2529',
        remark: this.form.remark,
        title: this.form.title,
        uploadFileIds: this.idArray.length?this.idArray.join(','):''
      }
      saveOrUpdateWarnInspection(params).then(res=> {
        if (res.code == 200) {
          Toast.success( (val == 1? '暂存':'上报') +'成功!')
          setTimeout(() => {
            this.onClickLeft()
          },1000)
        } else {
          Toast.fail(res.message || (val == 1? '暂存':'上报') + '失败！')
        }
        setTimeout(()=> {
          loading(false)
        },1000) 
      })
    },
    // 获取定位
    onClickRightIcon() {
      if(this.dis) {
        return 
      }
      // 获取定位
      loading(true)
      const geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        (r) => {
          if (r && r.point) {
            const { city, district, province, street, street_number } =
              r.address;
            const { lat, lng } = r.point;
            this.map.point = { lat, lng };
            this.map.address =
              province + city + district + street + street_number;
            this.form.address = this.map.address;
            // console.log("this.map", this.map);
          }
        },
        { enableHighAccuracy: true, SDKLocation: true }
      );
      loading(false)
    },
    //图片上传前校验
    beforeRead(file){
      if(file.length>9){
          Toast.fail('一次只能上传九张图片!');
          return false;
      }
      for(var i=0;i<file.length;i++){
        if(this.isImage(file[i].type) != true){
          Toast.fail('请上传图片!');
          return false;
        }
      }
      return true;
    },
    //判断上传的是否是图片
    isImage(ext) {
        return ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp', 'image/png', 'image/gif'].indexOf(ext.toLowerCase()) !== -1;
    },
    //刪除图片
    deleteImg(imgId,index) {
      this.$dialog.confirm({
          message: '要删除这张图片吗？',
      }).then(() => {
        // this.fileList.splice(index.index,1)
          if(this.idArray[index.index]!=undefined){
              loading(true)
              this.deleteFile(this.idArray[index.index],index.index);
          }
      }).catch(() => {
        return false
      });
    },
    //新增图片
    afterRead(event) {
      this.reLength = 0
      if(!event.length){
          this.fleLength = 1
          this.uploadAppFile(event.file.name,event.file);
      }else{
          this.fleLength = event.length
          for(var i=0;i<event.length;i++){
            this.uploadAppFile(event[i].file.name,event[i].file);
          }
      }
    },
    //删除图片
    deleteFile(imgId,index) {
        deleteFileAjax({ ids: imgId }).then(res => {
            if (res.code == 200) {
                this.fileList.splice(index,1)
                this.idArray.splice(index,1)
                Toast.success('删除成功');
            }else{
                  Toast.fail('删除失败');
            }
            loading(false)
        })
    },
    //上传图片
    uploadAppFile(name,file){
      loading(true)
      const params = new FormData()
      params.append("file", file);
      axios({
        method: 'post',
        url:
          config.devProxy +
          `/zdcommon/fileUpload/upload`,
          // 'https://jgjc.qinghai.gov.cn/prod-api/zdcommon/fileUpload/upload',
          data: params,
      }).then((res) => {
        const resData = res.data
        if(resData.code == 200) {
          this.idArray.push(resData.data.fid);
          this.reLength ++
          // alert('https://jgjc.qinghai.gov.cn/prod-api/zdcommon/fileUpload/upload')
          setTimeout(() => {
            if(this.reLength == this.fleLength) {
              loading(false)
              Toast.success('上传成功！');
            }
          })
        }else {
          Toast.fail('上传失败！');
        }
      })
    },
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>
<style scoped lang="scss">
.marketInspetionModify-box {
  width: 100%;
  height: 100%;
   /deep/.van-nav-bar__content{
    height: 100%;
    .van-nav-bar__title {
        margin-top: 0.1rem;
    }
    .van-nav-bar__left {
        margin-top: 0.1rem;
        padding-left: 0px;
    }
  }
  .box-content {
    .content-item {
      border-top: 1px solid #e3e3e3;
      &:nth-child(1) {
        border-top: none;
      }
      table {
        font-size: 0.38rem;
        font-weight: 550;
        margin: 10px;
        color: #646566;
      }
      table::before {
        position: absolute;
        left: 8px;
        color: #ee0a24;
        font-size: 14px;
        content: '*';
      }
      .item-upload {
        padding: 0px 10px;
      }
    }
    .item-title {
      .fieId-title-p {
        width: 0.5rem;
        display: flex;
        align-items: center;
        position: relative;
        left: -0.4rem;
      }
      .fieId-title-extra {
        display: none !important;
        color: #c8c9cc;
      }
      .fieId-title-extra-show {
        display: block !important;
      }
      /deep/.van-field__body {
        .van-field__clear {
          z-index: 999 !important;
        }
      }
      /deep/ .van-field__word-limit {
        position: absolute;
        top: 50%;
        right: -0.8rem;
        transform: translateY(-50%);
        margin: auto;
      }
    }
  }
  /deep/.van-field--disabled .van-field__label {
      color: #323233;
  }
  /deep/.van-cell {
    padding: 0px 15px;
    .van-field__label {
      font-size: 0.38rem;
      width: 1rem !important;
    }
    .van-field__body {
      textarea {
        line-height: 0.45rem !important;
        padding: 15px 0 !important;
      }
    }
    .van-field__control {
      font-size: 0.35rem !important;
      // line-height: normal !important;
    }
    .van-icon-location-o {
      font-size: 0.6rem !important;
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn {
      display: inline-block;
      width: 2rem;
      height: 1rem;
      line-height: 1rem;
      border-radius: 1rem;
      background-color: #3486e8;
      color: #ffffff;
      font-size: px2rem(45);
      text-align: center;
      vertical-align: middle;
    }
  }
}
</style>